/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, number as codecNumber, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { PlagiarismCaseSubmission } from './PlagiarismCaseSubmission';
const PlagiarismCaseParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['matchMax', codecNumber, 'match_max'],
    ['matchAvg', codecNumber, 'match_avg'],
    ['canSeeDetails', codecBoolean, 'can_see_details'],
    ['submissions', /* #__PURE__ */ codecArray(PlagiarismCaseSubmission)],
]);
export class PlagiarismCase extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PlagiarismCaseParser.decode(input).map(res => new PlagiarismCase(res));
    }
    static unsafeDecode(input) {
        return PlagiarismCase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PlagiarismCaseParser.encode(data);
    }
    static schema() {
        return PlagiarismCaseParser.schema();
    }
}
